import React from 'react';
import { SvgIcon } from '@mui/material';

export const XCircle = () => (
  <SvgIcon sx={{
    color: '#000000',
    width: '100%',
    height: 'auto',
    fontSize: 'unset',
  }}
  >
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 9L9 15M9 9L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SvgIcon>
);

export const ArrowRight = () => (
  <SvgIcon sx={{
    display: 'inline',
    color: '#000000',
    position: 'relative',
    top: 'clamp(0.125rem, 0.0625rem + 0.2778vw, 0.3125rem)',
    fontSize: 'inherit',
    verticalAlign: 'baseline',
    marginLeft: '0.25rem',
  }}
  >
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </SvgIcon>
);
